import { CheckCircle } from '@mui/icons-material';
import { Divider, Typography } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';
import GradientAiIcon from 'components/icons/GradientAiIcon';
import { Row } from 'further-ui/components/Layout';

const TOAST_DURATION_MS = 3000;

const grow = keyframes`
  from { width: 0%; }
  to { width: 100%; }
`;

const ToastCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fading',
})<{ fading?: boolean }>(({ theme, fading }) => ({
  position: 'fixed',
  top: 47.5,
  right: 14,
  width: 480,
  zIndex: 1400,
  background: 'rgba(253, 253, 253, 0.80)',
  borderRadius: 16,
  border: `1px solid ${theme.palette.grey[300]}`,
  boxShadow: '0 0 50px 0 rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(20px)',
  overflow: 'hidden',
  opacity: fading ? 0 : 1,
  transition: 'opacity 0.4s ease',
}));

const ToastHeader = styled(Row)(({ theme }) => ({
  padding: theme.spacing(5, 6, 4, 6),
}));

const ToastDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0, 6),
}));

const ToastBody = styled(Row)(({ theme }) => ({
  padding: theme.spacing(4, 6),
}));

const SuccessIcon = styled(CheckCircle)(({ theme }) => ({
  color: theme.palette.success.light,
  fontSize: 20,
  flexShrink: 0,
}));

const ProgressBar = styled('div')({
  height: 8,
  background: 'linear-gradient(90deg, #2196F3, #E91E63)',
  animation: `${grow} ${TOAST_DURATION_MS}ms linear forwards`,
});

type Props = {
  message: string;
  animationKey: string;
  fading?: boolean;
};

const AgentToast = ({ message, animationKey, fading }: Props) => (
  <ToastCard fading={fading}>
    <ToastHeader centered spacing="xs">
      <GradientAiIcon size={20} />
      <Typography variant="subtitle2">AI Agent</Typography>
    </ToastHeader>
    <ToastDivider />
    <ToastBody centered spacing="sm" justify="space-between">
      <Typography variant="body2" color="grey.600">
        {message}
      </Typography>
      <SuccessIcon />
    </ToastBody>
    <ProgressBar key={animationKey} />
  </ToastCard>
);

export default AgentToast;
